module.exports = __webpack_public_path__ + "img/ff02.167015f6.svg";